<template>
	<div>
		<header class="flex-apart">
			<h1 class="alpha heavy">Search Pack Bundles</h1>
			<div>
				<ul>
					<li v-if="$can('searchPackBundle.create')"><router-link
						:to="{name: 'searchPackBundles.create'}"
						class="button button--primary--small">Create Search Pack Bundle</router-link></li>
				</ul>
			</div>
		</header>
		<div>
			<loader v-if="!loaded"/>
			<div v-else class="section--floating">
				<table-filter :filters="filters"/>
				<div v-if="!items.length" class="nothing-to-see-here">
					<p>Nothing to display.</p>
				</div>
				<v-table v-if="items.length" :loading="gettingModels">
					<thead>
						<tr>
							<th align="left">Name</th>
							<th align="left">Products</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</thead>
					<tfoot>
						<tr>
							<th align="left">Name</th>
							<th align="left">Products</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</tfoot>
					<tbody>
						<tr v-for="(item, index) in items">
							<td v-html="item.name"/>
							<td v-html="item.products.length"/>
							<td align="right">
								<v-contextual>
									<v-contextual-option
										v-if="$can('update', item)"
										:route-to="{name: 'searchPackBundles.edit', params: {searchPackBundle: item.id}}">Edit</v-contextual-option>
								</v-contextual>
							</td>
						</tr>
					</tbody>
				</v-table>
				<paginator :links="links" :meta="meta"/>
			</div>
		</div>
	</div>
</template>
<script>
import Index from "../../../../components";

let index = new Index("searchPackBundles");

export default {
	computed: {
		...index.computed(),
	},

	methods: {
		...index.actions(),
	},

	created() {
		this.getModels();
	},
};
</script>
